"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const contexts_1 = require("@App/contexts");
const PaginationResultsBlock_1 = __importDefault(require("@Components/PaginationResultsBlock"));
const get_num_titles_1 = require("@App/helpers/pagination/get-num-titles");
const CSWorkItemTable_1 = __importDefault(require("@Scenes/RightsholderScene/MatchClaim/Claim/ClaimSearch/ClaimSearchPaginationTable/CSWorkItemTable"));
const PaginationAndLimit_1 = __importDefault(require("@Components/PaginationAndLimit"));
const ClaimSearchPaginationTable = (props) => {
    const { claimingToolSearchStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { selectWork, onChangePage, onChangeLimit, limit } = props;
    const results = claimingToolSearchStore.unclaimedWorks;
    if (!results) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const currentPagination = claimingToolSearchStore.unclaimedWorksPaginationInfo;
    const currentPage = currentPagination ? currentPagination.currentPage : 1;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PaginationResultsBlock_1.default, { totalResults: results.count, workNumTitles: (0, get_num_titles_1.getNumTitles)(results.count, currentPage, limit) }),
        react_1.default.createElement(CSWorkItemTable_1.default, { workModels: results.works, selectWork: selectWork }),
        results.count !== 0 && (react_1.default.createElement(PaginationAndLimit_1.default, { count: results.count, limit: limit, paginationInfo: currentPagination, onPageChange: onChangePage, onLimitChange: onChangeLimit }))));
};
exports.default = (0, mobx_react_1.observer)(ClaimSearchPaginationTable);
